import { useAppDispatch, useAppSelector } from '../../../../../lib/store';
import { selectFilterBy } from '../../../state/selector';
import { setFilterBy } from '../../../state/supervisorSlice';

export interface UseFilterBySectionResult {
  filterBy: string;
  handleFilterByChange: (value: string) => void;
}

export const useFilterBySection = (): UseFilterBySectionResult => {
  const dispatch = useAppDispatch();
  const filterBy = useAppSelector(selectFilterBy);

  const handleFilterByChange = (value: string) => {
    dispatch(setFilterBy(value));
  };
  return { filterBy, handleFilterByChange };
};
